export default __webpack_public_path__ + "static/media/portfolio-image.99ef7527.png";